/**
 * The browser's IANA timezone, e.g. "Asia/Dhaka".
 *
 * Sent on every request as `X-Opal-Timezone` so agents can state times in the
 * user's local zone rather than UTC. An IANA name, never a raw offset: an
 * offset cannot express daylight-saving rules, so a value captured in January
 * would be wrong in July.
 *
 * Falls back to 'UTC' only when `Intl` is unavailable, which no supported
 * browser does.
 */
export function getUserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'UTC';
  }
}
